// Day or night (owner, 2026-10-26: «الوضع الليلي والنهاري»). With no choice made the screens follow the
// device, as before; a choice made with the 🌙/☀️ button is remembered on this device for every
// DOREK screen. theme-boot.ts applies it before the page first paints (no flash of the other one).
import { h } from './dom.ts';

export type Theme = 'light' | 'dark';
export const THEME_KEY = 'dorek.theme';

/** What the screen shows now: the saved choice, or the device's own setting. */
export function currentTheme(): Theme {
  const set = document.documentElement.dataset.theme;
  if (set === 'light' || set === 'dark') return set;
  return window.matchMedia?.('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
}

export function setTheme(theme: Theme): void {
  document.documentElement.dataset.theme = theme;
  try {
    localStorage.setItem(THEME_KEY, theme);
  } catch {
    /* storage unavailable: the choice lasts until the page closes */
  }
}

/**
 * The 🌙/☀️ button. label(theme) gives its words in the screen's language ("الوضع الليلي" /
 * "Dark mode"): the mode a press switches to.
 */
export function themeButton(label: (next: Theme) => string): HTMLButtonElement {
  const button = h('button', { class: 'btn btn-ghost btn-sm theme-toggle', type: 'button', id: 'theme-toggle' });
  const draw = () => {
    const next: Theme = currentTheme() === 'dark' ? 'light' : 'dark';
    button.textContent = next === 'dark' ? '🌙' : '☀️';
    button.title = label(next);
    button.setAttribute('aria-label', label(next));
  };
  button.addEventListener('click', () => {
    setTheme(currentTheme() === 'dark' ? 'light' : 'dark');
    draw();
  });
  draw();
  return button;
}
